import { render, staticRenderFns } from "./editCommunity.vue?vue&type=template&id=4c56e25d"
import script from "./editCommunity.vue?vue&type=script&lang=js"
export * from "./editCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports